import { render, staticRenderFns } from "./CovidGraph.vue?vue&type=template&id=5cf7357c&"
import script from "./CovidGraph.vue?vue&type=script&lang=js&"
export * from "./CovidGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf7357c')) {
      api.createRecord('5cf7357c', component.options)
    } else {
      api.reload('5cf7357c', component.options)
    }
    module.hot.accept("./CovidGraph.vue?vue&type=template&id=5cf7357c&", function () {
      api.rerender('5cf7357c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/covid-graph/CovidGraph.vue"
export default component.exports